import { SimplePieChart } from "./SimplePieChart";

export { SimplePieChart };



// WEBPACK FOOTER //
// ./client/modules/core/Chart/RadialChart/PieChart/index.ts